<section class="toggle-form" [ngClass]="{ active: isTrainingItemSliderOpen }">
  <div class="formwrap">
    <div class="Header">
   <h2>
    <b>Add Training Item</b>
  </h2>
    <div>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="trainingItemSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    </div>
    <div class="general-container content">
      <p-tabView  [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
        <p-tabPanel
          header="Training Item Group"
        >
        <div class="content">
          <app-skill-training-item-group-details 
          [selectedScope]="skillScopes"
          [skillCode]="skillCode"
>

          </app-skill-training-item-group-details>
        </div>
        </p-tabPanel>
        <p-tabPanel header="Document" [rightIcon]="errorIconClassForDocumentTab">
            <div class="content">
                <app-skill-document-details 
                [selectedScope]="skillScopes"
                [skillCode]="skillCode"
                (activateTabIndex)="openCurrentTab($event)">
              </app-skill-document-details>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Course" [rightIcon]="errorIconClassForCourseTab">
          <app-skill-course-details 
          [selectedScope]="skillScopes"
          [skillCode]="skillCode"
           (activateTabIndex)="openCurrentTab($event)">
        </app-skill-course-details>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</section>